import React, { useEffect, useState } from "react"
import Select from "react-select"
import { SelectOption } from "../../../common/types"
import { isError } from "../../../state/helpers/Error"
import RowCustomStatusService from "../../../state/pricing/rowcustomstatus/RowCustomStatusService"

type Props = {
    multi: boolean
    onChangeCallback: (
        value: string[],
        label: string[],
    ) => void
    value: string[]
}

const RowCustomStatusSelectComponent = (props: Props) => {
    const [options, setOptions] = useState<SelectOption<string>[]>()

    useEffect(() => {
        (async () => {
            const res = await RowCustomStatusService.GetAll()
            if (!isError(res)) {
                const data = res.map(s => {
                    return {
                        value: s.getId(),
                        label: s.getName(),
                    }
                })
                setOptions(data)
            }
        }
        )()
    }, [])

    const onChange = (options: SelectOption<string>[]) => {
        props.onChangeCallback(
            options.map(o => {
                return o.value
            }),
            options.map(o => {
                return o.label
            }) as string[]
        )
    }

    return <Select
        multi={props.multi}
        value={props.value}
        onChange={onChange}
        options={options}
    />
}

export default RowCustomStatusSelectComponent


// WEBPACK FOOTER //
// ./src/pricing/rowcustomstatus/component/RowCustomStatusSelectComponent.tsx